module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("Добавить шаблон квитанции")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'bill-templates'
      }
    }
  }, [_vm._v("← Назад к Шаблонам квитанций")])], 1), _vm._v(" "), _c('h4', [_vm._v("Доступные переменные")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('bill-template-add-form', {
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("{contract_number}")]), _vm._v(" – номер договора"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("{debp}")]), _vm._v(" – сумма долга"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("{apartment}")]), _vm._v(" – номер квартиры"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("{block}")]), _vm._v(" – номер подъезда"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("{building}")]), _vm._v(" – номер дома"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("{street}")]), _vm._v(" – улица"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("{district}")]), _vm._v(" – район"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("{city}")]), _vm._v(" – город"), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37a150fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill_template/BillTemplateAdd.vue
// module id = 625
// module chunks = 0